import { API } from './api'

/** Thin fetch wrapper that always forwards credentials to the SMM API.
 *
 *  `credentials: 'include'` is required for the browser to send the
 *  Cloudflare Access cookie (CF_Authorization) on cross-origin calls from
 *  freecut.colectiva.casa to smm-api.colectiva.casa. Without it, every request
 *  arrives at the API anonymously and 401s once Access enforcement is on.
 *
 *  The wrapper joins paths with the configured base. Pass a `path` starting
 *  with `/`, e.g. `smmFetch('/api/drafts')`.
 */
export function smmFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(`${API}${path}`, {
    ...init,
    credentials: 'include',
  })
}
